<template>
  <div v-if="selectedFields != null && selectedFields.length > 0">
    <v-form ref="form" lazy-validation>
      <div class="d-flex justify-end mt-2 mb-2">
        <span class="text-caption text-right red--text">
          *Se a categoria selecionada for equipamento, os campos Unidade,
          Setor e Sub-setor serão herdados do equipamento.
        </span>
      </div>

      <div
        v-if="!hasDistinctFields"
        class="text-center py-8"
      >
        <strong>{{ $t('Nenhum campo distinto selecionado') }}</strong>
      </div>

      <div v-else>
        <div class="distinct-list pb-3">
          <div class="list my-2" v-for="(order, i) in orders" :key="i">
            <strong class="mr-2" style="min-width: 15px; max-width: 15px">
              {{ i + 1 }}
            </strong>

            <v-checkbox
              v-if="order.serviceOrderType == 5"
              hide-details="auto"
              :label="$t('Proativa')"
              v-model="order.isProactive"
              outlined
              class="mb-4"
            ></v-checkbox>

            <v-autocomplete
              v-model="order.equipmentId"
              append-icon="mdi-chevron-down"
              validate-on-blur
              :rules="[(v) => !!v || 'Selecione o equipamento']"
              @change="syncDepartmentAndSubDepartmentByEquipment(order)"
              v-if="category == 0 && !selectedFields.includes(FIELD_KEYS.IDENTIFICACAO)"
              item-text="identification"
              :items="equipments"
              item-value="id"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Identificação')"
              value="Identificação"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.identification }} / {{ item.name }}
                </span>
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-model="order.unidadeId"
              append-icon="mdi-chevron-down"
              v-if="!selectedFields.includes(FIELD_KEYS.UNIDADE)"
              :rules="[(v) => !!v || 'Selecione a unidade']"
              :items="unidades"
              item-text="name"
              validate-on-blur
              @change="category == 1 ? getDepartments(order) : null"
              item-value="id"
              :readonly="category == 0"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Unidade')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-model="order.departmentId"
              append-icon="mdi-chevron-down"
              :disabled="category == 1 && !order.unidadeId"
              v-if="!selectedFields.includes(FIELD_KEYS.SETOR)"
              :rules="[(v) => !!v || 'Selecione o setor']"
              @change="category == 1 ? getSubDepartments(order) : null"
              :items="order.departments ? order.departments : departments"
              item-text="name"
              item-value="id"
              validate-on-blur
              :readonly="category == 0"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Setor')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-model="order.subDepartmentId"
              append-icon="mdi-chevron-down"
              :disabled="category == 1 && !order.departmentId"
              v-if="!selectedFields.includes(FIELD_KEYS.SUB_SETOR)"
              :items="order.subDepartments ? order.subDepartments : []"
              item-text="name"
              item-value="id"
              validate-on-blur
              :readonly="category == 0"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="order.subDepartmentId == null ? 'N/A' : $t('Sub-setor')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <v-text-field
              v-model="order.location"
              v-if="category == 1 && !selectedFields.includes(FIELD_KEYS.LOCALIZACAO)"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              validate-on-blur
              hide-details="auto"
              :placeholder="$t('Localização')"
              value="Localização"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <v-text-field
              v-model="order.name"
              v-if="!selectedFields.includes(FIELD_KEYS.NOME_OS)"
              :rules="[(v) => !!v || 'Digite o nome para a O.S.']"
              outlined
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              validate-on-blur
              :placeholder="$t('Nome O.S.')"
              value="Nome O.S."
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <v-text-field
              v-model="order.requester"
              v-if="!selectedFields.includes(FIELD_KEYS.SOLICITANTE)"
              outlined
              :rules="[(v) => !!v || 'Digite o solicitante']"
              style="min-width: 200px"
              class="ma-1 primary-input"
              hide-details="auto"
              validate-on-blur
              :placeholder="$t('Solicitante')"
              value="Solicitante"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <v-autocomplete
              v-model="order.serviceOrderType"
              append-icon="mdi-chevron-down"
              style="min-width: 200px"
              :item-text="(item) => $t(item.text)"
              v-if="!selectedFields.includes(FIELD_KEYS.TIPO_OS)"
              :rules="[(v) => v != null || 'Selecione o Tipo da O.S.']"
              outlined
              class="ma-1 primary-input"
              validate-on-blur
              :items="types"
              hide-details="auto"
              :placeholder="$t('Tipo O.S.')"
              value="Solicitante"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="order.responsibleName"
              append-icon="mdi-chevron-down"
              style="min-width: 200px"
              v-if="!selectedFields.includes(FIELD_KEYS.RESPONSAVEL)"
              :rules="[(v) => !!v || 'Selecione o responsável']"
              item-text="name"
              validate-on-blur
              item-value="name"
              :items="users"
              outlined
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Responsável')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>

            <div
              v-if="!selectedFields.includes(FIELD_KEYS.DATA_HORA_SOLICITACAO)"
              style="min-width: 200px"
              class="ma-1"
            >
              <v-menu
                :close-on-content-click="false"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <input
                    class="date-input"
                    :value="formatDateTime(order.dateTimeRequest)"
                    placeholder="DD/MM/AAAA HH:MM"
                    readonly
                    style="width: 100%"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <date-picker
                  v-model="order.dateTimeRequest"
                  mode="dateTime"
                  is24hr
                  is-inline
                />
              </v-menu>
            </div>

            <v-text-field
              v-if="!selectedFields.includes(FIELD_KEYS.SOLICITACAO_RECLAMACAO)"
              :rules="[(v) => !!v || 'Digite a Solicitação / Reclamação']"
              outlined
              v-model="order.request"
              style="min-width: 200px"
              validate-on-blur
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Solicitação / Reclamação')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>

            <v-autocomplete
              v-if="
                !selectedFields.includes(FIELD_KEYS.OFICINA) &&
                institution.departmentTypes.includes(1)
              "
              v-model="order.workshopId"
              :items="workshopTypes"
              item-text="name"
              item-value="id"
              autocomplete="off"
              :rules="[(v) => v != null || 'Oficina obrigatório']"
              outlined
              class="ma-1 primary-input"
              hide-details="auto"
              :placeholder="$t('Oficina')"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>
          </div>
        </div>
      </div>
    </v-form>

    <div class="d-flex justify-end">
      <v-btn text @click="$emit('back')">
        {{ $t('Voltar') }}
      </v-btn>
      <v-btn color="primary mr-0" elevation="0" @click="confirm">
        {{ $t('Continue') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../../services/ApiService'
import { FIELD_KEYS } from './fieldKeys'

export default {
  name: 'DistinctFieldsStep',

  mounted() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.getWorkshops()

    setTimeout(() => {
      const slider = document.querySelector('.distinct-list')
      let isDown = false
      let startX
      let scrollLeft
      if (slider) {
        slider.addEventListener('mousedown', (e) => {
          isDown = true
          slider.classList.add('active')
          startX = e.pageX - slider.offsetLeft
          scrollLeft = slider.scrollLeft
        })
        slider.addEventListener('mouseleave', () => {
          isDown = false
          slider.classList.remove('active')
        })
        slider.addEventListener('mouseup', () => {
          isDown = false
          slider.classList.remove('active')
        })
        slider.addEventListener('mousemove', (e) => {
          if (!isDown) return
          e.preventDefault()
          const x = e.pageX - slider.offsetLeft
          const walk = (x - startX) * 3 //scroll-fast
          slider.scrollLeft = scrollLeft - walk
        })
      }
    }, 2000)
  },

  props: {
    selectedFields: { type: Array, default: () => [] },
    category: Number,
    users: Array,
    equipments: Array,
    types: Array,
    orders: {
      type: Array,
      default: () => [],
    },
    unidades: Array,
  },

  data() {
    return {
      FIELD_KEYS,
      institution: {},
      apiService: new ApiService(),
      departments: [],
      workshopTypes: [
        { text: 'Carpintaria', value: 0 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
    }
  },

  computed: {
    hasDistinctFields() {
      if (!this.selectedFields || this.selectedFields.length === 0) {
        return true
      }

      const distinctChecks = [
        this.category == 0 &&
          !this.selectedFields.includes(this.FIELD_KEYS.IDENTIFICACAO),
        this.category == 1 &&
          !this.selectedFields.includes(this.FIELD_KEYS.LOCALIZACAO),
        !this.selectedFields.includes(this.FIELD_KEYS.UNIDADE),
        !this.selectedFields.includes(this.FIELD_KEYS.SETOR),
        !this.selectedFields.includes(this.FIELD_KEYS.SUB_SETOR),
        !this.selectedFields.includes(this.FIELD_KEYS.NOME_OS),
        !this.selectedFields.includes(this.FIELD_KEYS.TIPO_OS),
        !this.selectedFields.includes(this.FIELD_KEYS.RESPONSAVEL),
        !this.selectedFields.includes(this.FIELD_KEYS.SOLICITANTE),
        !this.selectedFields.includes(this.FIELD_KEYS.DATA_HORA_SOLICITACAO),
        !this.selectedFields.includes(this.FIELD_KEYS.SOLICITACAO_RECLAMACAO),
        this.institution.departmentTypes.includes(1) &&
          !this.selectedFields.includes(this.FIELD_KEYS.OFICINA),
      ]

      return distinctChecks.some(Boolean)
    },
  },

  watch: {
    async orders() {
      if (this.category == 0) {
        for (const order of this.orders) {
          if (order.equipmentId) {
            await this.syncDepartmentAndSubDepartmentByEquipment(order)
          }
        }
      }

      const haveUnidade = this.orders.filter((x) => !!x.unidadeId)
      if (haveUnidade && haveUnidade.length > 0) {
        await this.getDepartments(this.orders[0])
        this.orders.forEach((order) => {
          if (order.departmentId) {
            const departmentsList = order.departments ? order.departments : this.departments
            const department = departmentsList.find((x) => x.id == order.departmentId)
            this.$set(order, 'subDepartments', department && department.subDepartments ? department.subDepartments : [])
          }
        })
      }
    },
  },

  methods: {
    async syncDepartmentAndSubDepartmentByEquipment(order) {
      if (this.category != 0) return

      const equipment = this.equipments.find((x) => x.id == order.equipmentId)
      if (!equipment) {
        order.departmentId = null
        order.subDepartmentId = null
        this.$set(order, 'subDepartments', [])
        return
      }

      order.unidadeId = equipment.unidadeId
      order.departmentId = equipment.departmentId

      if (order.unidadeId) {
        await this.getDepartments(order)
      }

      this.getSubDepartments(order, false)
      order.subDepartmentId = equipment.subDepartmentId
    },

    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    async getDepartments(order) {
      await this.apiService
        .get(`department/list/unidade/${order.unidadeId}`, true, false)
        .then((response) => {
          this.departments = response.content
          order.departments = response.content
          this.departLoading = false
        })
        .catch(() => {
          this.departLoading = false
        })
    },

    getSubDepartments(order, resetSubDepartment = true) {
      if (resetSubDepartment) {
        order.subDepartmentId = null
      }

      const departmentsList = order.departments ? order.departments : this.departments
      const department = departmentsList.find((x) => x.id == order.departmentId)
      order.subDepartments =
        department && department.subDepartments ? department.subDepartments : []
    },

    formatDateTime(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    },

    confirm() {
      if (this.$refs.form.validate()) {
        const institutionId = JSON.parse(localStorage.getItem('institution')).id

        const result = this.orders.map((x) => {
          const equip = this.equipments.find((y) => y.id == x.equipmentId)

          return {
            ...x,
            institutionId,
            unidadeId: x.unidadeId ? x.unidadeId : equip.unidadeId,
            dateTimeRequest: x.dateTimeRequest
              ? moment(x.dateTimeRequest).format('YYYY-MM-DDTHH:mm:ss')
              : null,
          }
        })

        this.$emit('confirm', result)
      }
    },
  },
}
</script>

<style>
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}
.vc-popover-content-wrapper {
  z-index: 999 !important;
}
</style>

<style scoped>
.distinct-list {
  overflow-x: scroll;
  margin-bottom: 12px;
}
.distinct-list::-webkit-scrollbar {
  border-radius: 8px;
  height: 7px;
}

.distinct-list::-webkit-scrollbar-thumb {
  border-radius: 8px;
  height: 7px;
  background: #777;
}

.list {
  display: flex;
  align-items: center;
  overflow-x: visible;
  white-space: nowrap;
}
</style>
